export default "__VITE_ASSET__cb289bee__"